export default "__VITE_ASSET__d01287d3__"